module.exports = __webpack_public_path__ + "img/success.cd820e79.png";